<template>
  <div class="w-full h-full">
    <div v-if="loader == false">
      <div
        class="flex flex-col gap-2 lg:flex-row w-full lg:items-center lg:justify-between"
      >
        <h2 class="text-2xl font-semibold">Test Taken List</h2>
        <div
          class="flex justify-start lg:justify-end items-center gap-2 lg:gap-4 py-2 lg:py-4"
        >
          <form
            v-if="this.test_completed.length > 0"
            @submit.prevent="searchTestList"
            class="flex gap-2 lg:gap-4"
          >
            <input
              type="text"
              name="test_search"
              id="test_search"
              v-model="test_search"
              placeholder="Search by name"
              class="rounded-lg w-[80%] h-10 lg:w-[240px]"
            />
            <button type="submit" class="btn text-sm px-4 rounded-lg">
              Search
            </button>
          </form>
          <router-link :to="{ name: 'adminDashboard' }">
            <button type="button" class="btn text-sm px-4 h-10 rounded-lg">
              Back
            </button></router-link
          >
        </div>
      </div>

      <div>
        <div
          v-if="this.test_completed.length > 0"
          class="overflow-scroll border border-t-0 shadow-md text-start"
        >
          <table class="min-w-full bg-primary2">
            <thead class="bg-primary border-b text-start sticky top-0 text">
              <tr class="">
                <th
                  scope="col"
                  class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
                >
                  S.No
                </th>
                <th
                  scope="col"
                  class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
                >
                  Name
                </th>
                <th
                  scope="col"
                  class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
                >
                  Email
                </th>
                <th
                  scope="col"
                  class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
                >
                  Grade
                </th>
                <th
                  scope="col"
                  class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
                >
                  Scholarship
                </th>
                <!-- <th
                          scope="col"
                          class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
                        >
                          Action
                        </th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-if="message !== ''">
                <td
                  class="text-sm font-normal px-4 py-2 xl:px-6 xl:py-4"
                  colspan="5"
                >
                  <div v-if="message" class="w-full text-center text-error">
                    <p>{{ message }}</p>
                  </div>
                </td>
              </tr>
              <tr
                v-else
                v-for="(el, index) in this.test_completed"
                :key="index"
                class="border-b"
              >
                <td
                  class="text-sm text-gray-900 font-normal px-4 py-2 xl:px-6 xl:py-4 whitespace-nowrap"
                >
                  {{ index + (this.current_page_number - 1) * 20 + 1 }}
                </td>
                <td
                  class="text-sm text-gray-900 font-normal px-4 py-2 xl:px-6 xl:py-4 whitespace-nowrap"
                >
                  {{ el.user.display_name }}
                </td>
                <td
                  class="text-sm text-gray-900 font-normal px-4 py-2 xl:px-6 xl:py-4 whitespace-nowrap"
                >
                  {{ el.user.email }}
                </td>
                <td
                  class="text-sm text-gray-900 font-normal px-4 py-2 xl:px-6 xl:py-4 whitespace-nowrap"
                >
                  {{ el.reservation.grade }}
                </td>
                <td
                  class="text-sm text-gray-900 font-normal px-4 py-2 xl:px-6 xl:py-4 whitespace-nowrap"
                >
                  {{ el.reservation.scholarship }}
                </td>
                <!-- <td
                          class="text-sm text-gray-900 font-normal px-4 py-2 xl:px-6 xl:py-4 whitespace-nowrap"
                        >
                          <button
                            class="cursor-pointer text-[#2563EB] hover:underline"
                          >
                            View
                          </button>
                        </td> -->
              </tr>
            </tbody>
            <tfoot class="bg-primary border-b text">
              <tr class="">
                <td colspan="5" class="px-4 py-2 xl:px-6 xl:py-4">
                  <div class="w-full flex justify-between items-center">
                    <h2>Showing {{ first_value }} to {{ last_value }}</h2>
                    <h2 class="">
                      Page {{ current_page_number }} of
                      {{ total_pages }}
                    </h2>
                    <div class="flex gap-2 lg:gap-4">
                      <button
                        v-if="test_prev"
                        @click="prevTestList"
                        class="btn px-2 py-1 rounded-md"
                      >
                        prev
                      </button>
                      <button
                        v-if="test_next"
                        @click="nextTestList"
                        class="btn px-2 py-1 rounded-md"
                      >
                        next
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div v-else class="" style="height: calc(100vh - 80px)">
          <div class="flex flex-col justify-center items-center h-full">
            <img
              :src="no_data"
              class="w-full h-[200px] object-contain"
              alt=""
              srcset=""
            />
            <h1 class="dark_text text-lg">NO DATA FOUND</h1>
          </div>
        </div>
      </div>
    </div>
    <div v-if="loader" class="flex flex-col justify-center items-center">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      Loading...
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "TestView",
  data() {
    return {
      loader: true,
      test_completed: [],
      total_test_std_list: [],
      current_page_number: "",
      test_search: "",
      no_data: require(`${process.env.VUE_APP_NODATA}`),
      page_no: 1,
      test_next: "",
      test_prev: "",
      first_value: 1,
      last_value: 20,
      message: "",
      total_pages: "",
    };
  },
  async created() {
    await this.getTestList();
  },

  computed: {
    ...mapGetters(["userInfo", "isAuthenticated"]),
  },
  methods: {
    async getTestList() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/reservation-booking/list/?page=${this.page_no}`
        )
        .then((resp) => {
          if (resp.data.data.status == 200) {
            this.test_completed = resp.data.data.data;
            setTimeout(() => {
              this.loader = false;
            }, 2000);
            this.test_next = resp.data.next;
            this.test_prev = resp.data.previous;
            this.current_page_number = resp.data.current_page_number;
            this.first_value = (this.current_page_number - 1) * 20 + 1;
            this.last_value = this.current_page_number * 20;
            this.total_pages = resp.data.total_pages;
          } else {
            setTimeout(() => {
              this.loader = false;
            }, 2000);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // next test taken student list
    async nextTestList() {
      await axios
        .get(`${this.test_next}`)
        .then((resp) => {
          this.total_test_std_list = resp.data;
          console.log("this.total_test_std_list", this.total_test_std_list);
          this.test_completed = resp.data.data.data;
          this.test_next = resp.data.next;
          this.test_prev = resp.data.previous;
          this.current_page_number = resp.data.current_page_number;
          this.first_value = (this.current_page_number - 1) * 20 + 1;
          this.last_value = this.current_page_number * 20;
          this.total_pages = resp.data.total_pages;
          // if(this.test_next==null){
          //   this.last_value=resp.data.count
          // }
          this.loader = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // previous test taken student list
    async prevTestList() {
      await axios
        .get(`${this.test_prev}`)
        .then((resp) => {
          this.total_test_std_list = resp.data;
          this.test_completed = resp.data.data.data;
          this.test_next = resp.data.next;
          this.test_prev = resp.data.previous;
          this.current_page_number = resp.data.current_page_number;
          this.total_pages = resp.data.total_pages;
          this.first_value = (this.current_page_number - 1) * 20 + 1;
          this.last_value = (this.last_value / 20 - 1) * 20;
          this.loader = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // serach test taken student list
    searchTestList() {
      axios
        .get(
          `${process.env.VUE_APP_API}/reservation-booking/list/?search=${this.test_search}`,
          {
            headers: {
              Authorization: `Token ${this.userInfo.data.token}`,
            },
          }
        )
        .then((response) => {
          console.log("response 309", response);
          if (response.data.data.status == 200) {
            this.test_completed = response.data.data.data;
            this.message = "";
          } else if (response.data.status == 400) {
            this.message = response.data.message;
          }
        })
        .catch((error) => {
          console.error("Error fetching leads:", error);
        });
    },
  },
};
</script>

<style></style>
